import React, { useEffect, useState } from 'react'
import { v4 as uuidv4 } from 'uuid';
import axios from 'axios';
import Modal from 'react-bootstrap/Modal';
import { usePapaParse } from 'react-papaparse';
import { useCSVDownloader } from 'react-papaparse';

function ItemsList({ serverUrl, user, titleOfPage, globalUserId, globalToken   }) {
    const { jsonToCSV } = usePapaParse();
    const { CSVDownloader, Type } = useCSVDownloader();
    const [yearFilter, setYearFilter] = useState("all")
    const [labFilter, setLabFilter] = useState("all")

    const [itemsViewMode, setItemsViewMode] = useState("View");
    const [viewIndividualItem, setViewIndividualItem] = useState(false);

    const [code, setCode] = useState("");
    const [name, setName] = useState("");
    const [type, setType] = useState("");
    const [HSN_SAC_Code, setHSN_SAC_Code] = useState("");
    const [MRP, setMRP] = useState("");
    const [cost, setCost] = useState("");
    const [avlQty, setAvlQty] = useState("");
    const [avlCard, setAvlCard] = useState("");
    const [settings, setSettings] = useState({});

    const [allItems, setAllItems] = useState([]);

    const [editItemData, setEditItemData] = useState({});

    const [itemView, setItemView] = useState([]);


    const addItem = async (e) => {
        e.preventDefault()

        const query = {
            "code": code,
            "name": name,
            "type": type,
            "HSN_SAC_Code": HSN_SAC_Code,
            "MRP": MRP,
            "cost": cost,
            "avlQty": avlQty,
            "avlCard": avlCard,
            "settings": settings,
        }
        const saveTheLab = await axios.post(serverUrl + "/items/add", query);
        if (saveTheLab.status == 200) {
            // console.log(saveTheLab.data)
            updateLog({ "Name": "Item Added", "Item code": code, "Details": query })
            resetAll();
            setItemsViewMode("View");
            getAllItems();
        } else {
            console.log(saveTheLab.data)
        }
    }
    const editItem = async (e) => {
        e.preventDefault();
        const query = {
            "code": code,
            "name": name,
            "type": type,
            "HSN_SAC_Code": HSN_SAC_Code,
            "MRP": MRP,
            "cost": cost,
            "avlQty": avlQty,
            "avlCard": avlCard,
            "settings": settings,
        }
        const saveTheItem = await axios.post(serverUrl + "/items/edit", query);
        if (saveTheItem.status == 200) {
            // console.log(saveTheLab.data)
            delete editItemData._id
            delete editItemData.updatedAt
            delete editItemData.createdAt
            query["previousValue"] = editItemData
            updateLog({ "Name": "Item Edited", "Item code": code, "Details": query })
            resetAll();
            setItemsViewMode("View");
            getAllItems();
        } else {
            console.log(saveTheItem.data)
        }
    }

    const resetAll = () => {
        setCode("");
        setName("");
        setType("");
        setHSN_SAC_Code("");
        setMRP("");
        setCost("");
        setAvlQty("");
        setAvlCard("");
        setSettings({});
    }

    const getLastId = async () => {
        const getLastItemCode = await axios.post(serverUrl + "/Items/getLastLab");

        if (getLastItemCode.status == 200) {
            setCode(getLastItemCode.data)
        } else {
            setCode("DD0001")
        }
    }

    const getAllItems = async () => {
        const getAllItems = await axios.post(serverUrl + "/items/find", { code: "all" });
        if (getAllItems.status == 200) {
            // console.log(getAllItems.data)
            setAllItems(getAllItems.data);
        } else {
            console.log("No Data Found");
        }
    }

    const getItemData = async (code) => {
        const getAllLabs = await axios.post(serverUrl + "/items/find", { code: code });
        if (getAllLabs.status == 200) {
            const chosenLab = getAllLabs.data[0]
            // console.log(chosenLab)
            setEditItemData(chosenLab);

            setCode(chosenLab.code);
            setName(chosenLab.name);
            setType(chosenLab.type);
            setHSN_SAC_Code(chosenLab.HSN_SAC_Code);
            setMRP(chosenLab.MRP);
            setCost(chosenLab.cost);
            setAvlQty(chosenLab.avlQty);
            setAvlCard(chosenLab.avlCard);
            setSettings(chosenLab.settings);

        } else {
            console.log("No Data Found");
        }
    }

    const viewItem = async (code) => {
        const viewItem = allItems.filter((item) => { return item.code === code });
        setItemView(viewItem)
    }


    const updateLog = async (data) => {
        const dataSet = {
            "userId": user.userId,
            "changes": data,
        }
        const updateNow = await axios.post(serverUrl + "/users/updateLog", dataSet)
        if (updateNow.status == 200) {
            console.log(updateNow.data)
        } else {
            console.log(updateNow.data)
        }
    }


    useEffect(() => {
        // getLastId()
        getAllItems()
    }, [])
    return (
        <>
            <div className='h-100 w-100 dataTableSet d-flex flex-column overflow-auto'>
                {
                    itemsViewMode === "Edit" ?
                        <>
                            <div className='w-100 upperMoonsSearchBackground themeTextColor border-0 fs-4 p-0 shadow-sm text-center'>Edit Item</div>
                            <div className='p-2 p-md-3 p-lg-3 overflow-auto rounded-0 h-100'>
                                <form action="" onSubmit={(e) => { editItem(e); }}>
                                    <div className="container-fluid">
                                        <div className="row">
                                            <div className="col-12 col-lg-6 col-xl-6 mb-3">
                                                <div className="container-fluid">
                                                    <div className="row">
                                                        <div className="col-4 col-sm-3 d-flex align-items-center">Product Type</div>
                                                        <div className="col-8 col-sm-9 d-flex align-items-center">
                                                            <select name="" id="" className='customFieldForDence' style={{ maxWidth: "300px" }} value={type} onInput={(e) => { setType(e.target.value) }}>
                                                                <option value="Type A 1">Type A 1</option>
                                                                <option value="Type A 2">Type A 2</option>
                                                                <option value="Type A 3">Type A 3</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-12 col-lg-6 col-xl-6 mb-3">
                                                <div className="container-fluid">
                                                    <div className="row">
                                                        <div className="col-4 col-sm-3 d-flex align-items-center">Product Name</div>
                                                        <div className="col-8 col-sm-9 d-flex align-items-center">
                                                            <input type="text" className='customFieldForDence w-100' style={{ maxWidth: "300px" }} required defaultValue={name} onInput={(e) => { setName(e.target.value) }} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-12 col-lg-6 col-xl-6 mb-3">
                                                <div className="container-fluid">
                                                    <div className="row">
                                                        <div className="col-4 col-sm-3 d-flex align-items-center">Product Code</div>
                                                        <div className="col-8 col-sm-9 d-flex align-items-center">
                                                            <input type="text" className='customFieldForDence w-100' style={{ maxWidth: "300px" }} required defaultValue={code} onInput={(e) => { setCode(e.target.value) }} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-12 col-lg-6 col-xl-6 mb-3">
                                                <div className="container-fluid">
                                                    <div className="row">
                                                        <div className="col-4 col-sm-3 d-flex align-items-center">HSN_CODE/ SAC</div>
                                                        <div className="col-8 col-sm-9 d-flex align-items-center">
                                                            <input type="text" className='customFieldForDence w-100' style={{ maxWidth: "300px" }} required defaultValue={HSN_SAC_Code} onInput={(e) => { setHSN_SAC_Code(e.target.value) }} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-12 col-lg-6 col-xl-6 mb-3">
                                                <div className="container-fluid">
                                                    <div className="row">
                                                        <div className="col-4 col-sm-3 d-flex align-items-center">MRP</div>
                                                        <div className="col-8 col-sm-9 d-flex align-items-center">
                                                            <input type="text" className='customFieldForDence w-100' style={{ maxWidth: "300px" }} required defaultValue={MRP} onInput={(e) => { setMRP(e.target.value) }} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-12 col-lg-6 col-xl-6 mb-3">
                                                <div className="container-fluid">
                                                    <div className="row">
                                                        <div className="col-4 col-sm-3 d-flex align-items-center">Cost</div>
                                                        <div className="col-8 col-sm-9 d-flex align-items-center">
                                                            <input type="text" className='customFieldForDence w-100' style={{ maxWidth: "300px" }} required defaultValue={cost} onInput={(e) => { setCost(e.target.value) }} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-5">
                                            <div className="col-12 col-lg-6 col-xl-6 mb-3">
                                                <div className="container-fluid">
                                                    <div className="row">
                                                        <div className="col-4 col-sm-3 d-flex align-items-start pt-1">Number of Available Quantity</div>
                                                        <div className="col-8 col-sm-9 d-flex align-items-center">
                                                            <textarea className='customFieldForDence w-100' style={{ maxWidth: "300px" }} required defaultValue={avlQty} onInput={(e) => { setAvlQty(e.target.value) }} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-12 col-lg-6 col-xl-6 mb-3">
                                                <div className="container-fluid">
                                                    <div className="row">
                                                        <div className="col-4 col-sm-3 d-flex align-items-center">Number of Available Card</div>
                                                        <div className="col-8 col-sm-9 d-flex align-items-center">
                                                            <input type="text" className='customFieldForDence w-100' style={{ maxWidth: "300px" }} required defaultValue={avlCard} onInput={(e) => { setAvlCard(e.target.value) }} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col d-flex justify-content-between gap-3">
                                                <button
                                                    type='button'
                                                    className='btn btn-secondary px-4 py-2 rounded-pill fw-bold' onClick={(e) => {
                                                        setItemsViewMode("View");
                                                        resetAll();
                                                    }}>Back to All Items</button>
                                                <input type="submit" value="Update" className='themeButtons rounded-pill px-5 py-2 fw-bold' />
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </>
                        :
                        itemsViewMode === "New" ?
                            <>
                                <div className='w-100 upperMoonsSearchBackground themeTextColor border-0 fs-4 p-0 shadow-sm text-center'>Create New Item</div>
                                <div className='p-2 p-md-3 p-lg-3 overflow-auto rounded-0 h-100'>
                                    <form action="" onSubmit={(e) => { addItem(e); }}>
                                        <div className="container-fluid">
                                            <div className="row">
                                                <div className="col-12 col-lg-6 col-xl-6 mb-3">
                                                    <div className="container-fluid">
                                                        <div className="row">
                                                            <div className="col-4 col-sm-3 d-flex align-items-center">Product Type</div>
                                                            <div className="col-8 col-sm-9 d-flex align-items-center">
                                                                <select name="" id="" className='customFieldForDence' style={{ maxWidth: "300px" }} required value={type} onInput={(e) => { setType(e.target.value) }}>
                                                                    <option value="Type A 1">Type A 1</option>
                                                                    <option value="Type A 2">Type A 2</option>
                                                                    <option value="Type A 3">Type A 3</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-12 col-lg-6 col-xl-6 mb-3">
                                                    <div className="container-fluid">
                                                        <div className="row">
                                                            <div className="col-4 col-sm-3 d-flex align-items-center">Product Name</div>
                                                            <div className="col-8 col-sm-9 d-flex align-items-center">
                                                                <input type="text" className='customFieldForDence w-100' style={{ maxWidth: "300px" }} required value={name} onInput={(e) => { setName(e.target.value) }} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-12 col-lg-6 col-xl-6 mb-3">
                                                    <div className="container-fluid">
                                                        <div className="row">
                                                            <div className="col-4 col-sm-3 d-flex align-items-center">Product Code</div>
                                                            <div className="col-8 col-sm-9 d-flex align-items-center">
                                                                <input type="text" className='customFieldForDence w-100' style={{ maxWidth: "300px" }} required value={code} onInput={(e) => { setCode(e.target.value) }} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-12 col-lg-6 col-xl-6 mb-3">
                                                    <div className="container-fluid">
                                                        <div className="row">
                                                            <div className="col-4 col-sm-3 d-flex align-items-center">HSN_CODE/ SAC</div>
                                                            <div className="col-8 col-sm-9 d-flex align-items-center">
                                                                <input type="text" className='customFieldForDence w-100' style={{ maxWidth: "300px" }} required value={HSN_SAC_Code} onInput={(e) => { setHSN_SAC_Code(e.target.value) }} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-12 col-lg-6 col-xl-6 mb-3">
                                                    <div className="container-fluid">
                                                        <div className="row">
                                                            <div className="col-4 col-sm-3 d-flex align-items-center">MRP</div>
                                                            <div className="col-8 col-sm-9 d-flex align-items-center">
                                                                <input type="text" className='customFieldForDence w-100' style={{ maxWidth: "300px" }} required value={MRP} onInput={(e) => { setMRP(e.target.value) }} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-12 col-lg-6 col-xl-6 mb-3">
                                                    <div className="container-fluid">
                                                        <div className="row">
                                                            <div className="col-4 col-sm-3 d-flex align-items-center">Cost</div>
                                                            <div className="col-8 col-sm-9 d-flex align-items-center">
                                                                <input type="text" className='customFieldForDence w-100' style={{ maxWidth: "300px" }} required value={cost} onInput={(e) => { setCost(e.target.value) }} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row mb-5">
                                                <div className="col-12 col-lg-6 col-xl-6 mb-3">
                                                    <div className="container-fluid">
                                                        <div className="row">
                                                            <div className="col-4 col-sm-3 d-flex align-items-start pt-1">Number of Available Quantity</div>
                                                            <div className="col-8 col-sm-9 d-flex align-items-center">
                                                                <textarea className='customFieldForDence w-100' style={{ maxWidth: "300px" }} required value={avlQty} onInput={(e) => { setAvlQty(e.target.value) }} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-12 col-lg-6 col-xl-6 mb-3">
                                                    <div className="container-fluid">
                                                        <div className="row">
                                                            <div className="col-4 col-sm-3 d-flex align-items-center">Number of Available Card</div>
                                                            <div className="col-8 col-sm-9 d-flex align-items-center">
                                                                <input type="text" className='customFieldForDence w-100' style={{ maxWidth: "300px" }} required value={avlCard} onInput={(e) => { setAvlCard(e.target.value) }} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col d-flex justify-content-between gap-3">
                                                    <button
                                                        type='button'
                                                        className='btn btn-secondary px-4 py-2 rounded-pill fw-bold' onClick={(e) => {
                                                            setItemsViewMode("View");
                                                        }}>Back to All Items</button>
                                                    <input type="submit" value="Create" className='themeButtons rounded-pill px-5 py-2 fw-bold' />
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </>
                            :
                            itemsViewMode === "View" ?
                                <>
                                    <div className='w-100 upperMoonsSearchBackground themeTextColor border-0 fs-4 p-0 shadow-sm text-center'>{titleOfPage}</div>
                                    <div className='p-2 p-md-3 p-lg-3 overflow-auto d-flex flex-column rounded-0 h-100'>
                                        <div className='mb-3 d-flex gap-3 justify-content-between  flex-wrap'>
                                            <div className='d-flex gap-5 flex-wrap'>
                                                <button className='themeButtons px-4 py-2 rounded-pill fw-bold' onClick={(e) => {
                                                    setItemsViewMode("New");
                                                }}>Add Item</button>
                                            </div>
                                            <div className='d-flex gap-5 flex-wrap'>
                                                <CSVDownloader
                                                    type={Type.Button}
                                                    filename={'ItemsList'}
                                                    bom={true}
                                                    config={{
                                                        delimiter: ',',
                                                    }}
                                                    className="btn btn-success px-4 py-2 rounded-pill fw-bold"
                                                    data={
                                                        jsonToCSV(allItems)
                                                    }
                                                >
                                                    Export to Excel
                                                </CSVDownloader>
                                            </div>
                                        </div>
                                        <div className="themeTextColor fs-5 my-3 fw-bold d-flex gap-1">
                                            <span>
                                                Total Records:
                                            </span>
                                            {
                                                allItems.length > 0 ?
                                                    allItems.length
                                                    :
                                                    "0"
                                            }
                                        </div>
                                        <div className='overflow-auto'>
                                            <table className='table table-light table-bordered w-100 table-striped pb-5 text-center m-0'>
                                                <thead className=''>
                                                    <tr align="center" className='sticky-top'>
                                                        <th width="5%"><span className='text-nowrap'>#</span></th>
                                                        <th><span className='text-nowrap'>Product Type</span></th>
                                                        <th><span className='text-nowrap'>Product Name</span></th>
                                                        <th><span className='text-nowrap'>Product Code</span></th>
                                                        <th><span className='text-nowrap'>HSN Code/ SAC</span></th>
                                                        <th><span className='text-nowrap'>AVL QTY</span></th>
                                                        <th><span className='text-nowrap'>AVL Card</span></th>
                                                        <th width="1%"><span className='text-nowrap'>Options</span></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        allItems.length > 0 ?
                                                            allItems.map((data, key) => {
                                                                return (
                                                                    <tr key={key}>
                                                                        <td>{key + 1}</td>
                                                                        <td>{data.type}</td>
                                                                        <td>{data.name}</td>
                                                                        <td>{data.code}</td>
                                                                        <td>{data.HSN_SAC_Code}</td>
                                                                        <td>{data.avlQty}</td>
                                                                        <td>{data.avlCard}</td>
                                                                        <td valign='middle'>
                                                                            <div className='d-flex gap-2 align-items-center'>
                                                                                <button className='btn btn-sm btn-secondary px-3 py-1 rounded w-100' style={{ minWidth: "50px" }} onClick={(e) => { setViewIndividualItem(true); viewItem(data.code); }}>View</button>
                                                                                <button className='themeButtons px-3 py-1 rounded w-100' style={{ minWidth: "50px" }} onClick={() => { setItemsViewMode("Edit"); getItemData(data.code); }}>Edit</button>
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                )
                                                            })
                                                            :
                                                            <tr>
                                                                <td valign='middle' colSpan={8}>
                                                                    <div className="upperMoonsSearchBackground p-2 themeTextColor fw-bold">
                                                                        No Data
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                    }

                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </>
                                :
                                <div className="alert alert-danger text-center fs-6">
                                    Unknown View
                                </div>
                }
            </div>


            <Modal
                show={viewIndividualItem}
                onHide={() => { setViewIndividualItem(false); setItemView([]) }}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered>
                <Modal.Header closeButton>
                    <Modal.Title>
                        <span className='themeTextColor'>
                            Item Code: {itemView[0]?.code}
                        </span>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='overflow-auto d-flex flex-column rounded-0 h-100'>
                        <table className='table table-light table-bordered w-100 table-striped pb-5 text-center m-0'>
                            <thead className=''>
                                <tr align="center" className='sticky-top'>
                                    <th>Product Type</th>
                                    <th>Product Name</th>
                                    <th>Product Code</th>
                                    <th>HSN Code/ SAC</th>
                                    <th>AVL QTY</th>
                                    <th>AVL Card</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    itemView.length > 0 ?
                                        itemView.map((data, key) => {
                                            return (
                                                <tr key={key}>
                                                    <td>{data.type}</td>
                                                    <td>{data.name}</td>
                                                    <td>{data.code}</td>
                                                    <td>{data.HSN_SAC_Code}</td>
                                                    <td>{data.avlQty}</td>
                                                    <td>{data.avlCard}</td>
                                                </tr>
                                            )
                                        })
                                        :
                                        <tr>
                                            <td valign='middle' colSpan={8}>
                                                <div className="upperMoonsSearchBackground p-2 themeTextColor fw-bold">
                                                    No Data
                                                </div>
                                            </td>
                                        </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className='w-100 d-flex justify-content-center'>
                        <input type="submit" value="OK" className='themeButtons rounded-pill px-5 py-2 fw-bold' onClick={() => { setViewIndividualItem(false); setItemView([]) }} />
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default ItemsList